import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Flame } from "lucide-react";

export function StreakRing({ size = 84, refreshKey }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/plan/streak").then(r => setS(r.data)).catch(() => {}); }, [refreshKey]);
  if (!s) return null;
  const r = (size - 10) / 2, c = 2 * Math.PI * r;
  const pct = s.today.total ? s.today.pct : 0;
  const dash = (pct / 100) * c;
  return (
    <div className="flex items-center gap-4" data-testid="streak-ring">
      <div className="relative shrink-0" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.07)" strokeWidth="6" fill="none" />
          <circle cx={size / 2} cy={size / 2} r={r} stroke={s.today.complete ? "#34d399" : "var(--aria-primary)"} strokeWidth="6" fill="none"
            strokeLinecap="round" strokeDasharray={`${dash} ${c - dash}`} className="transition-[stroke-dasharray] duration-700 ease-out"
            style={{ filter: `drop-shadow(0 0 6px ${s.today.complete ? "#34d399" : "var(--aria-primary)"})` }} />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-display text-lg leading-none" data-testid="streak-today-pct">{pct}%</span>
          <span className="text-[9px] uppercase tracking-wider text-[var(--aria-text-muted)]">today</span>
        </div>
      </div>
      <div>
        <div className="flex items-center gap-1.5">
          <Flame size={16} className={s.current > 0 ? "text-amber-400" : "text-[var(--aria-text-muted)]"} />
          <span className="font-display text-2xl leading-none" data-testid="streak-current">{s.current}</span>
          <span className="text-xs text-[var(--aria-text-muted)]">day streak</span>
        </div>
        <div className="text-[11px] text-[var(--aria-text-muted)] mt-1">best {s.best} · {s.today.done}/{s.today.total} tasks today</div>
        <div className="flex gap-1 mt-2" data-testid="streak-days">
          {s.days.map(d => (
            <span key={d.date} title={d.date} className={`w-2 h-2 rounded-full ${d.complete ? "bg-emerald-400 shadow-[0_0_6px_#34d399]" : "bg-white/10"}`} />
          ))}
        </div>
      </div>
    </div>
  );
}
